import './admin'
import './filemimetypeplugin'
import './filenameplugin'
import './filesizeplugin'
import './filesystemtagsplugin'
import './requestremoteaddressplugin'
import './requesttimeplugin'
import './requesturlplugin'
import './requestuseragentplugin'
import './usergroupmembershipplugin'

window.OCA.WorkflowEngine = OCA.WorkflowEngine
